import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=51e6a1c8&scoped=true"
import script from "./page2.vue?vue&type=script&lang=js"
export * from "./page2.vue?vue&type=script&lang=js"
import style0 from "./page2.vue?vue&type=style&index=0&id=51e6a1c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6a1c8",
  null
  
)

export default component.exports